import { useauthMeQuery } from '@/types/generated/graphql';

export const useLoginMethod = () => {
  const authMeResult = useauthMeQuery();
  const isPasswordLogin = authMeResult?.data?.authMe?.data?.user?.identityProvider === null;

  return {
    isPasswordLogin,
  };
};
